module.exports = __webpack_public_path__ + "34bc775d/img/cadBim.e369a02a.png";